import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26ec2dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-location-indicator-bubble-container" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["bubble", { underline: $props.underline, 'is-full': $props.isFullSeat }]),
      innerHTML: $setup.DOMPurify.sanitize($props.displayText),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick')))
    }, null, 10 /* CLASS, PROPS */, _hoisted_2)
  ]))
}